function handleSubMenuClick(subGroup, setCurrentPage, clickTriggeredRef) {
  clickTriggeredRef.current = true;
  setCurrentPage(subGroup);
}

export default handleSubMenuClick;
